import React, { useEffect, useState } from "react";
import { CircularProgress } from '@material-ui/core';
import Validator from "../../services/validator";
import CookieManager from "../../services/CookieManager";
import API from "../../services/api";
import { toast } from "react-toastify";
import { ErrorToast, SuccessToast } from "../../pure-components/CustomToast";

export default function CorporateUserForm(props) {
  const [user, setUser] = useState({});
  const [helperText, setHelperText] = useState({});
  let validator = new Validator();
  const profileData = CookieManager.getCookie("user-data")?.length
    ? JSON.parse(CookieManager.getCookie("user-data"))
    : null;
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let userData = { ...user };
    userData.startDate = new Date().toISOString().substr(0, 10);
    if (profileData?.userType === "ADMIN") {
      userData.companyName = profileData.companyName;
      userData.taxNumber = profileData.taxNumber;
    }
    setUser(userData);
  }, []);

  const handleInputChange = (e, key) => {
    let value = key === 'tos' ? e : e.target.value;
    let temp = { ...helperText };
    if (key === 'first_name') {
      let res = validator.setValue(value).isNotEmpty();
      if (!res?.status) temp[key] = "First name can not be blank";
      else temp[key] = "";
    }
    if (key === 'email') {
      let res = validator.setValue(value).isNotEmpty().isEmail();
      if (!res?.status) temp[key] = "Please Enter valid email";
      else temp[key] = "";
    }
    if (key === 'companyName') {
      let res = validator.setValue(value).isNotEmpty();
      if (!res?.status) temp[key] = "Please Enter valid company name";
      else temp[key] = "";
    }
    if (key === 'totalLicenseCount') {
      let res = validator.setValue(value).isNotEmpty();
      if (!res?.status) temp[key] = "Please Enter valid license count";
      else temp[key] = "";
    }
    if (key === 'taxNumber') {
      let res = validator.setValue(value).isNotEmpty().isGSTIN();
      if (!res?.status) temp[key] = res.mssg;
      else temp[key] = "";
    }
    if (key === 'startDate') {
      let res = validator.setValue(value).isNotEmpty();
      let startDate = new Date(value).getTime();
      let now = new Date();
      now.setUTCHours(0, 0, 0, 0);
      now = now.getTime();
      if (!res?.status || startDate < now) temp[key] = "Please select valid date.";
      else temp[key] = "";
    }
    setHelperText(temp);
    let tempUser = { ...user };
    tempUser[key] = value;
    setUser(tempUser);
  };

  const createUser = async () => {
    setSaving(true);
    let counter = 0;
    let temp = { ...helperText };
    let resFirstName = new Validator(user.first_name).isNotEmpty().isString();
    if (!resFirstName?.status) {
      temp['first_name'] = "First name can not be blank";
      counter++;
    } else temp['first_name'] = "";
    let resEmail = new Validator(user.email).isNotEmpty().isString().isEmail();
    if (!resEmail?.status) {
      temp['email'] = "Please Enter valid email";
      counter++;
    } else temp["email"] = "";
    let resCompanyName = new Validator(user.companyName).isNotEmpty();
    if (!resCompanyName?.status) {
      temp['companyName'] = "Please Enter valid company name";
      counter++;
    } else temp["companyName"] = "";
    let resTaxNumber = new Validator(user.taxNumber).isNotEmpty().isGSTIN();
    if (!resTaxNumber?.status) {
      temp['taxNumber'] = resTaxNumber.mssg;
      counter++;
    } else temp["taxNumber"] = "";
    let resTotalLicenseCount = new Validator(user.totalLicenseCount).isNotEmpty();
    if (!resTotalLicenseCount?.status && profileData?.userType === "SUPER_ADMIN") {
      temp['totalLicenseCount'] = "Please Enter valid license count";
      counter++;
    } else temp["totalLicenseCount"] = "";
    let resStartDate = new Validator(user.startDate).isNotEmpty();
    let startDate = new Date(user.startDate).getTime();
    let now = new Date();
    now.setUTCHours(0, 0, 0, 0);
    now = now.getTime();
    if (!resStartDate?.status || startDate < now) {
      temp['startDate'] = "Please Enter valid start date";
      counter++;
    } else temp["startDate"] = "";
    setHelperText(temp);

    if (counter === 0) {
      try {
        let userData = { ...user };
        if (profileData?.userType === "SUPER_ADMIN") userData.userType = "ADMIN";
        else if (profileData?.userType === "ADMIN") userData.userType = "CORPORATE";

        if (profileData?.userType === "ADMIN" && profileData?.email?.length > 0)
          userData['admin'] = profileData.email;

        const data = await API.createCorporateAdmin({ ...userData });
        if (data?.success) {
          toast(({ closeToast }) => <SuccessToast message="User created successfully" />);
          props.setShowAddNewUserForm(false);
          setUser({});
          await props.fetchUserList(); // Awaited in case fetchUserList is async
        } else {
          toast(({ closeToast }) => <ErrorToast message={data.mssg || "Failed to create user"} />);
        }
      } catch (error) {
        toast(({ closeToast }) => <ErrorToast message="Failed to create user" />);
      }
    }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 flex items-start sm:items-center justify-center z-50 bg-black bg-opacity-50 backdrop-blur-sm p-2 sm:p-4 overflow-y-auto">
      <div className="bg-white rounded-xl sm:rounded-2xl shadow-2xl p-4 sm:p-6 max-w-lg sm:max-w-2xl w-full min-h-fit max-h-[98vh] sm:max-h-[95vh] overflow-y-auto border border-gray-100 mt-2 sm:mt-0">
        <div className="flex items-start justify-between mb-4 sm:mb-6">
          <div className="flex-1 pr-2">
            <h2 className="text-lg sm:text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Corporate Details
            </h2>
            <p className="text-gray-500 text-xs sm:text-sm mt-1 hidden sm:block">
              Fill in the information below to create a new corporate user
            </p>
          </div>
          <button
            className="w-7 h-7 sm:w-8 sm:h-8 rounded-full hover:bg-gray-200 flex items-center justify-center transition-colors flex-shrink-0 border-none"
            onClick={() => props.setShowAddNewUserForm(false)}
          >
            <span className="text-gray-400 text-lg">×</span>
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4 sm:mb-6">
          <div className="space-y-1 sm:space-y-2">
            <label className="block text-xs sm:text-sm font-semibold text-gray-800">
              Full Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="first_name"
              value={user?.first_name || ''}
              onChange={(e) => handleInputChange(e, 'first_name')}
              placeholder="Enter full name"
              className="w-full border-2 border-gray-200 rounded-lg px-3 py-2 sm:px-4 sm:py-3 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 placeholder-gray-400 text-sm sm:text-base"
              required
            />
            {helperText.first_name && (
              <div className="text-red-500 text-xs flex items-center mt-1">
                <span className="mr-1">⚠</span>
                {helperText.first_name}
              </div>
            )}
          </div>

          <div className="space-y-1 sm:space-y-2">
            <label className="block text-xs sm:text-sm font-semibold text-gray-800">
              Email Address <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={user?.email || ''}
              onChange={(e) => handleInputChange(e, 'email')}
              placeholder="Enter email address"
              className="w-full border-2 border-gray-200 rounded-lg px-3 py-2 sm:px-4 sm:py-3 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 placeholder-gray-400 text-sm sm:text-base"
              required
            />
            {helperText.email && (
              <div className="text-red-500 text-xs flex items-center mt-1">
                <span className="mr-1">⚠</span>
                {helperText.email}
              </div>
            )}
          </div>

          <div className="space-y-1 sm:space-y-2">
            <label className="block text-xs sm:text-sm font-semibold text-gray-800">
              Company Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="companyName"
              value={user?.companyName || ''}
              onChange={(e) => handleInputChange(e, 'companyName')}
              placeholder="Enter company name"
              className={`w-full border-2 border-gray-200 rounded-lg px-3 py-2 sm:px-4 sm:py-3 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 placeholder-gray-400 text-sm sm:text-base ${
                profileData?.userType === "ADMIN" ? 'bg-gray-50 cursor-not-allowed' : ''
              }`}
              disabled={profileData?.userType === "ADMIN"}
              required
            />
            {helperText.companyName && (
              <div className="text-red-500 text-xs flex items-center mt-1">
                <span className="mr-1">⚠</span>
                {helperText.companyName}
              </div>
            )}
          </div>

          <div className="space-y-1 sm:space-y-2">
            <label className="block text-xs sm:text-sm font-semibold text-gray-800">
              GST Number <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="taxNumber"
              value={user?.taxNumber || ''}
              onChange={(e) => handleInputChange(e, 'taxNumber')}
              placeholder="Enter GST number"
              className={`w-full border-2 border-gray-200 rounded-lg px-3 py-2 sm:px-4 sm:py-3 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 placeholder-gray-400 text-sm sm:text-base ${
                profileData?.userType === "ADMIN" ? 'bg-gray-50 cursor-not-allowed' : ''
              }`}
              disabled={profileData?.userType === "ADMIN"}
              required
            />
            {helperText.taxNumber && (
              <div className="text-red-500 text-xs flex items-center mt-1">
                <span className="mr-1">⚠</span>
                {helperText.taxNumber}
              </div>
            )}
          </div>

          {profileData?.userType === "SUPER_ADMIN" && (
            <div className="space-y-1 sm:space-y-2">
              <label className="block text-xs sm:text-sm font-semibold text-gray-800">
                Number of Users <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                name="totalLicenseCount"
                value={user?.totalLicenseCount || ''}
                onChange={(e) => handleInputChange(e, 'totalLicenseCount')}
                placeholder="Enter number of users"
                min="1"
                className="w-full border-2 border-gray-200 rounded-lg px-3 py-2 sm:px-4 sm:py-3 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 placeholder-gray-400 text-sm sm:text-base"
                required
              />
              {helperText.totalLicenseCount && (
                <div className="text-red-500 text-xs flex items-center mt-1">
                  <span className="mr-1">⚠</span>
                  {helperText.totalLicenseCount}
                </div>
              )}
            </div>
          )}

          <div className="space-y-1 sm:space-y-2">
            <label className="block text-xs sm:text-sm font-semibold text-gray-800">
              Start Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              name="startDate"
              value={user?.startDate || ''}
              onChange={(e) => handleInputChange(e, 'startDate')}
              min={new Date().toISOString().substr(0, 10)}
              className="w-full border-2 border-gray-200 rounded-lg px-3 py-2 sm:px-4 sm:py-3 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 text-sm sm:text-base"
              required
            />
            {helperText.startDate && (
              <div className="text-red-500 text-xs flex items-center mt-1">
                <span className="mr-1">⚠</span>
                {helperText.startDate}
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-4 pt-3 sm:pt-4 border-t border-gray-100">
          <button
            type="button"
            className="w-full sm:w-auto px-4 sm:px-6 py-2 sm:py-3 rounded-lg border-2 border-gray-300 text-gray-700 font-semibold hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-200 text-sm sm:text-base"
            onClick={() => props.setShowAddNewUserForm(false)}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            type="button"
            className="w-full sm:w-auto px-4 sm:px-8 py-2 sm:py-3 rounded-lg bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105 text-sm sm:text-base"
            onClick={createUser}
            disabled={saving}
          >
            {saving ? (
              <span className="flex items-center justify-center">
                <CircularProgress size={16} className="text-white -ml-1 mr-2" />
                Saving...
              </span>
            ) : (
              'Save User'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
